import React from "react";
import { GitMerge } from "lucide-react";
import { Panel } from "@/components/common/Panel";

export function ConsolidationResultsPanel({ consolidation }) {
    if (!consolidation) return null;
    return (
        <Panel eyebrow="Consolidation Intelligence" title={`Redundancy analysis (${consolidation.length})`}>
            {consolidation.length === 0 ? (
                <p className="text-sm text-slate-500 font-mono py-4 text-center">No significant overlap detected — role library is well-decomposed.</p>
            ) : (
                <div className="space-y-2">
                    {consolidation.map((s, i) => (
                        <div key={i} className="panel p-3 border-l-2 border-cyan-500/40">
                            <div className="flex items-center gap-2">
                                <GitMerge size={14} className="text-cyan-400" />
                                <span className="text-sm text-white font-mono">{s.role_a} ↔ {s.role_b}</span>
                                <span className="text-[10px] font-mono px-1.5 py-0.5 rounded-sm bg-cyan-500/15 text-cyan-300 border border-cyan-500/30">
                                    {Math.round(s.similarity * 100)}% overlap
                                </span>
                            </div>
                            <p className="text-xs text-slate-400 mt-1">{s.recommendation}</p>
                        </div>
                    ))}
                </div>
            )}
        </Panel>
    );
}
